exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile{background:url(\"https://d1ffehxzshl7nv.cloudfront.net/blog/wp-content/uploads/sites/4/2017/09/interactive-notification-e1523282952179.png\") no-repeat;width:500px;height:400px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ce5de168","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/push/TemplatesNotificacaoPush.vue
// module id = 978
// module chunks = 0